import { useState, useCallback } from 'react';

export const useVideoSound = () => {
  const [isMuted, setIsMuted] = useState(true);

  const toggleSound = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);

  return { isMuted, toggleSound };
};